import { render, staticRenderFns } from "./Liga1.vue?vue&type=template&id=f66eaa14&scoped=true"
import script from "./Liga1.vue?vue&type=script&lang=js"
export * from "./Liga1.vue?vue&type=script&lang=js"
import style0 from "./Liga1.vue?vue&type=style&index=0&id=f66eaa14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66eaa14",
  null
  
)

export default component.exports